<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="authors-note">
<h1>Author’s Note</h1>
<p>This is fiction. However, everything in this fiction is based on facts. Hence, this is fiction based on facts. In other words, this is fact-based fiction.</p>
<p>This is what I see through the peeping hole of my mind when I am silent in the long silence with no thought in it.</p>
<p>Kè Su Thar</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?89997a28